module.exports = "/images/download_report_white.svg?077d414242616f3ddaca68e3c78bcea1";